import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listApprovalTasks } from '@ebalance/proto/bffuser/v1/approval_task_service-ApprovalTaskService_connectquery'
import {
  ListApprovalTasksRequestSchema,
  type ListApprovalTasksResponse,
} from '@ebalance/proto/bffuser/v1/approval_task_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 承認案件一覧を取得する hook。
 * ステータス / 業務プロセスの絞り込みは frontend 側で行うため、
 * BFF には全件取得リクエストを送る。
 * 30秒ポーリング (spec: 非機能要件) で新規案件をリアルタイム反映。
 */
export function useListApprovalTasks(): UseQueryResult<
  ListApprovalTasksResponse,
  ConnectError
> {
  return useQuery(
    listApprovalTasks,
    create(ListApprovalTasksRequestSchema, {}),
    {
      refetchInterval: 30_000, // 30秒ポーリング (spec 非機能要件)
    },
  )
}
